// extracted by mini-css-extract-plugin
module.exports = {"Intro":"home_Intro__3_IOK","text":"home_text__2tH8I","home":"home_home__1QzKp"};